import CustomTag from 'components/CustomTag'
import React from 'react'

const CandidatesStatus = ({ status, isExpCandidate, isSeened }) => {
  let colorType
  let tagMessage
  switch (status) {
    case 'ACTIVE':
    case 'APPLIED':
      colorType = 'grey'
      tagMessage = 'Applied'
      break
    case 'SHORTLISTED':
    case 1:
      colorType = 'green'
      tagMessage = 'Shortlisted'
      break
    case 'REJECTED':
    case -1:
      colorType = 'red'
      tagMessage = 'Rejected'
      break
    case 'HOLD':
      colorType = 'grey'
      tagMessage = 'HOLD'
      break
    case 'PENDING':
      colorType = 'grey'
      tagMessage = 'Pending'
      break
    default:
      if (isSeened === true) {
        colorType = 'orange'
        tagMessage = 'Viewed'
      } else if (isExpCandidate && status) {
        colorType = 'green'
        tagMessage = 'Shortlisted'
      } else {
        colorType = 'grey'
        tagMessage = 'Applied'
      }
      break
  }

  return <CustomTag colorType={colorType} message={tagMessage} />
}

export default CandidatesStatus
